import DivisionalClassModel                        from 'Models/invoice/DivisionalClassModel';
import InvoiceItemGroupModel                       from 'Models/invoice/InvoiceItemGroupModel';
import OwnerLocationModel                          from 'Models/invoice/OwnerLocationModel';
import VatModel                                    from 'Models/invoice/VatModel';
import ContractIterationItemActivityModel          from 'Models/sales/ContractIterationItemActivityModel';
import ContractIterationItemEventItemActivityModel from 'Models/sales/ContractIterationItemEventItemActivityModel';
import QuotationItemActivityModel                  from 'Models/sales/QuotationItemActivityModel';
import QuotationItemEventItemActivityModel         from 'Models/sales/QuotationItemEventItemActivityModel';
import doc                                         from 'decorators/doc';
import model                                       from 'decorators/model';
import { EmptyModel }                              from 'decorators/resolvableUrn';
import { Timestampable }                           from 'helpers/traits';
import { Blamable }                                from 'helpers/traits';
import InvoicePrivateApiModel                      from 'modelx/models/abstracts/InvoicePrivateApiModel';

@model.staticLabel('InvoiceItem')
@model.urnResource('invoice_item')
@doc.path('/invoice_items/{?id}')
export default class InvoiceItemModel extends Blamable(Timestampable(InvoicePrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'accountingCodeEntity': id;
		'invoiceItemGroup.invoice': id;
		'invoiceItemGroup.invoice.billingGroup.billingOwner.ownerSubPartition': id;
		'invoiceItemGroup.invoice.billingGroup.billingOwner.ownerSubPartition.subPartitionUrn': Urn;
		'invoiceItemGroup.invoice.billingPeriod': id;
		'invoiceItemGroup.invoice.billingPeriod.partitionUrn': Urn;
		'invoiceItemGroup.invoice.date': string | Date;
		'invoiceItemGroup.invoice.date[after]': string | Date;
		'invoiceItemGroup.invoice.date[before]': string | Date;
		'invoiceItemGroup.invoice.date[strictly_after]': string | Date;
		'invoiceItemGroup.invoice.date[strictly_before]': string | Date;
		'invoiceItemMetas': id;
		'invoiceItemMetas.reference': InvoiceInvoiceItemMetaReference;
		'invoiceItemMetas.value': id;
		'ownerLocation': id;
		'ownerLocation.locationUrn': Urn;
		'sourceUrn': Urn;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'label': string;
		'priceExclTax': string;
		'quantity': string;
	}> = {};

	@doc.string declare accountingVatCode: string;
	@doc.string declare description: string;
	@doc.model(DivisionalClassModel) declare divisionalClass: DivisionalClassModel;
	@doc.model(InvoiceItemGroupModel) declare invoiceItemGroup: InvoiceItemGroupModel;
	@doc.string declare label: string;
	@doc.string declare note: string;
	@doc.model(OwnerLocationModel) declare ownerLocation: OwnerLocationModel;
	@doc.number declare priceExclTax: number;
	@doc.string declare quantity: string;
	@doc.number declare totalPriceExclTax: number;
	@doc.model(VatModel) declare vat: VatModel;
	@doc.string declare vatRate: string;

	@model.resolvableUrn({ attributeName: 'sourceUrn' })
	public declare source: (
		ContractIterationItemEventItemActivityModel
		| QuotationItemEventItemActivityModel
		| ContractIterationItemActivityModel
		| QuotationItemActivityModel
		| EmptyModel
	);
}
